<form
  [formGroup]="filterForm"
  (ngSubmit)="handleSubmitFilters()"
  [class]="!showFilters ? 'hide-filters' : ''"
>
  <div class="filter-fields">
    <app-input-wrapper
      [id]="'adv-filter-wrapper-date'"
      [titleLabel]="getFieldInfo('dateRange').title"
      [infoLabel]="getFieldInfo('dateRange').info"
      [invalid]="getFieldInfo('dateRange').invalid"
    >
      <div style="display: flex; gap: 16px; width: 330px" formGroupName="dateRange">
        <mat-form-field appearance="outline" (click)="picker1.open()" style="cursor: pointer">
          <input
            matInput
            id="adv-filter-start-date"
            formControlName="start"
            [matDatepicker]="picker1"
            placeholder="Fecha inicial"
            i18n-placeholder="@@startDateLabel"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" (click)="picker2.open()" style="cursor: pointer">
          <input
            matInput
            id="adv-filter-end-date"
            formControlName="end"
            [matDatepicker]="picker2"
            placeholder="Fecha final"
            i18n-placeholder="@@endDateLabel"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
    </app-input-wrapper>

    <app-input-wrapper
      [id]="'adv-filter-wrapper-score'"
      [titleLabel]="getFieldInfo('scoreRange').title"
      [infoLabel]="getFieldInfo('scoreRange').info"
      [invalid]="getFieldInfo('scoreRange').invalid"
    >
      <div style="display: flex; gap: 16px" formGroupName="scoreRange">
        <mat-form-field appearance="outline" style="width: 157px">
          <input
            matInput
            id="adv-filter-score-min"
            type="number"
            formControlName="min"
            placeholder="Score mín."
            min="0"
            [appInputRegex]="'^[0-9]*$'"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 157px">
          <input
            matInput
            id="adv-filter-score-max"
            type="number"
            formControlName="max"
            placeholder="Score máx."
            max="1000"
            [appInputRegex]="'^[0-9]*$'"
          />
        </mat-form-field>
      </div>
    </app-input-wrapper>

    <app-input-wrapper
      [id]="'adv-filter-wrapper-restrictives'"
      [titleLabel]="getFieldInfo('restrictivesRange').title"
      [infoLabel]="getFieldInfo('restrictivesRange').info"
      [invalid]="getFieldInfo('restrictivesRange').invalid"
    >
      <div style="display: flex; gap: 16px" formGroupName="restrictivesRange">
        <mat-form-field appearance="outline" style="width: 157px">
          <input
            matInput
            id="adv-filter-restrictives-min"
            type="number"
            formControlName="min"
            placeholder="Cant mín."
            i18n-placeholder="@@qtdMinLabel"
            [appInputRegex]="'^[0-9]*$'"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 157px">
          <input
            matInput
            id="adv-filter-restrictives-max"
            type="number"
            formControlName="max"
            placeholder="Cant máx."
            i18n-placeholder="@@qtdMaxLabel"
            [appInputRegex]="'^[0-9]*$'"
          />
        </mat-form-field>
      </div>
    </app-input-wrapper>

    <app-input-wrapper
      [id]="'adv-filter-wrapper-internal-code'"
      style="min-width: 230px; max-width: 330px; width: 100%"
      [titleLabel]="getFieldInfo('internalCode').title"
      [infoLabel]="getFieldInfo('internalCode').info"
      [invalid]="getFieldInfo('internalCode').invalid"
    >
      <mat-form-field appearance="outline">
        <input
          matInput
          id="adv-filter-internal-code"
          type="text"
          formControlName="internalCode"
          maxlength="30"
          appInputRegex
          [placeholder]="internalCodeInputPlaceholder"
        />
      </mat-form-field>
    </app-input-wrapper>

    <app-input-wrapper
      [id]="'adv-filter-wrapper-segment'"
      style="min-width: 230px; max-width: 330px; width: 100%"
      [titleLabel]="getFieldInfo('segment').title"
      [infoLabel]="getFieldInfo('segment').info"
      [invalid]="getFieldInfo('segment').invalid"
    >
      <mat-form-field appearance="outline">
        <input
          matInput
          id="adv-filter-segment"
          type="text"
          formControlName="segment"
          maxlength="30"
          appInputRegex
          [placeholder]="internalCodeInputPlaceholder"
        />
      </mat-form-field>
    </app-input-wrapper>
  </div>

  <div class="filter-buttons">
    <app-button
      [id]="'adv-filter-btn-clear'"
      (click)="handleClearFilters()"
      [buttonStyle]="'outline'"
      size="large"
      [disabled]="buttonsDisabled"
      i18n="@@removeFilters"
    >
      Quitar filtros
    </app-button>

    <app-button
      [id]="'adv-filter-btn-apply'"
      type="submit"
      size="large"
      [buttonStyle]="'danger'"
      [disabled]="buttonsDisabled || !filterForm.valid"
      i18n="@@applyFilters"
    >
      Aplicar Filtros
    </app-button>
  </div>
</form>
